import { render, staticRenderFns } from "./BrandMarketInsightTab.vue?vue&type=template&id=ad8a6d5e&scoped=true"
import script from "./BrandMarketInsightTab.vue?vue&type=script&lang=js"
export * from "./BrandMarketInsightTab.vue?vue&type=script&lang=js"
import style0 from "./BrandMarketInsightTab.vue?vue&type=style&index=0&id=ad8a6d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8a6d5e",
  null
  
)

export default component.exports